import React, { useEffect, useState } from 'react'
import { Box } from '../../atoms/AppBox'
import { Chute } from 'interfaces/templates'
import IconClose from '../../../assets/Close.png'
import AppButton from 'components/atoms/AppButton/AppButton'

interface Props {
    onChange: (chutes: Chute[]) => void
    chutes: Chute[] | null
    onClose?: () => void
    disabledChutes?: number[]
}

interface ChuteAux {
    chute: number
    type: string
    selected: boolean
    id?: number
}

const PatternSelectChute = ({
    chutes,
    onChange,
    onClose,
    disabledChutes = [],
}: Props) => {
    const [chutesAux, setChutesAux] = useState<ChuteAux[]>([])

    useEffect(() => {
        if (chutes && chutes.length > 0) {
            const newChutes = chutes.map((item) => ({
                chute: item.chute,
                type: item.type,
                selected: false,
                id: item.id,
            }))
            setChutesAux(newChutes)
        }
    }, [chutes])

    const handleClick = (item: Chute) => {
        const newChutes = chutesAux.map((chute) =>
            chute.id === item.id
                ? { ...chute, selected: !chute.selected }
                : chute
        )
        setChutesAux(newChutes)
    }

    const handleAccept = () => {
        const selectedChutes: Chute[] = chutesAux
            .filter((chute) => chute.selected)
            .map((chute) => ({
                chute: chute.chute,
                type: chute.type,
                id: chute.id,
            }))
        onChange(selectedChutes)
    }

    const isAssigned = (item: ChuteAux): boolean => {
        const isDisabledGlobally =
            item.id !== undefined && disabledChutes.includes(item.id)
        const isSelectedHere = item.selected
        return isDisabledGlobally && !isSelectedHere
    }

    return (
        <div className="max-w-[587px]">
            <Box>
                <div className="flex justify-between items-center mb-4">
                    <p className="text-xl font-semibold leading-[24px] text-[#141A1F]">
                        Asignar Chutes
                    </p>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600 text-xl font-bold focus:outline-none"
                    >
                        <img src={IconClose} alt="IconClose" />
                    </button>
                </div>
                <hr className="w-[calc(100%+2rem)] -mx-4 mb-5 border-t border-gray-200" />

                <div className="flex flex-wrap gap-3 justify-center">
                    {chutesAux.map((item) => {
                        if (item.type === 'not_available' || isAssigned(item)) {
                            return (
                                <button
                                    key={item.id}
                                    className={`border rounded-md flex justify-center items-center w-[40px] h-[40px] cursor-not-allowed
                    ${
                        isAssigned(item)
                            ? 'bg-yellow-100 border-yellow-600 text-yellow-600'
                            : 'bg-gray-300 border-gray-300 text-gray-400 bg-opacity-50'
                    }`}
                                >
                                    {item.chute}
                                </button>
                            )
                        } else {
                            return (
                                <button
                                    key={item.id}
                                    onClick={() => handleClick(item)}
                                    className={`border rounded-md flex justify-center items-center w-[40px] h-[40px]
                    ${
                        item.selected
                            ? 'bg-ebony-300 border-ebony-500 text-ebony-500'
                            : ''
                    }`}
                                >
                                    {item.chute}
                                </button>
                            )
                        }
                    })}
                </div>

                <div className="flex gap-5 mt-10 justify-center">
                    <div className="flex gap-3 items-center">
                        <div className="w-[20px] h-[20px] border rounded-md bg-ebony-300 border-ebony-500"></div>
                        <h3>Seleccionados</h3>
                    </div>
                    <div className="flex gap-3 items-center">
                        <div className="w-[20px] h-[20px] border rounded-md bg-yellow-100 border-yellow-300 text-yellow-300"></div>
                        <h3>Asignados</h3>
                    </div>
                    <div className="flex gap-3 items-center">
                        <div className="w-[20px] h-[20px] border rounded-md "></div>
                        <h3>Sin seleccionar</h3>
                    </div>
                </div>

                <div className="flex justify-end gap-3 mt-12">
                    <AppButton
                        title="Descartar"
                        onClick={onClose}
                        state="ghost"
                        size="md"
                        className="font-bold"
                    />
                    <AppButton
                        title="Aceptar"
                        onClick={handleAccept}
                        state="primary"
                        size="md"
                        className="bg-[#00B894] text-white font-semibold"
                    />
                </div>
            </Box>
        </div>
    )
}

export default PatternSelectChute
